import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import {
  FormCheckbox,
  FormDropdown,
  FormInput,
} from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, formValues, initialize, reduxForm } from 'redux-form'
import { Button, Form, Icon, Segment, Table } from 'semantic-ui-react'
import ComponentPlaceholder from '../../Helper/ComponentPlaceholder'
import ProductFamilyModal from './ProductFamilyModal'
import ProductRow from './ProductRow'

const i18nkey = 'admin.product.browser.'

const mapStateToProps = (state, ownProps) => {
  const { products, product, productsLoading } = state.product
  const pathLeaves = [{ value: -1, text: I18n.t('global.no_category') }].concat(
    state.categories.pathLeaves
  )
  return { pathLeaves, products, product, productsLoading }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      initialize,
    },
    dispatch
  )
}

class ProductBrowser extends React.Component {
  getProductRows() {
    const { exclude = [] } = this.props
    const { products = [], onSelect, selectable } = this.props
    const {
      categoryFilter,
      filterActive,
      filterInactive,
      filterArchived,
      filterProduct,
      filterFamily,
      filterFamilyMember,
      filterText,
    } = this.props
    let filteredProducts = products.filter(
      (product) => !exclude.includes(product.id)
    )
    if (categoryFilter > 0)
      filteredProducts = filteredProducts.filter((product) =>
        product.category_ids.find((categoryId) => categoryId === categoryFilter)
      )
    if (!filterActive)
      filteredProducts = filteredProducts.filter(
        (product) => product.status !== 'active'
      )
    if (!filterInactive)
      filteredProducts = filteredProducts.filter(
        (product) => product.status !== 'inactive'
      )
    if (!filterArchived)
      filteredProducts = filteredProducts.filter(
        (product) => product.status !== 'archived'
      )
    if (!filterProduct)
      filteredProducts = filteredProducts.filter(
        (product) => product.kind !== 'product' || product.family_ids.length > 0
      )
    if (!filterFamily)
      filteredProducts = filteredProducts.filter(
        (product) => product.kind !== 'family'
      )
    if (!filterFamilyMember)
      filteredProducts = filteredProducts.filter(
        (product) => product.family_ids.length === 0
      )
    if (filterText)
      filteredProducts = filteredProducts.filter(
        (product) =>
          (product.article_number &&
            product.article_number
              .toLowerCase()
              .includes(filterText.toLowerCase())) ||
          (product.title_de &&
            product.title_de
              .toLowerCase()
              .includes(filterText.toLowerCase())) ||
          (product.title_fr &&
            product.title_fr.toLowerCase().includes(filterText.toLowerCase()))
      )

    const maxProducts = 25
    if (filteredProducts.length > maxProducts) {
      filteredProducts = filteredProducts.slice(0, maxProducts)
      filteredProducts.push({
        message: I18n.t(i18nkey + 'product_list_too_long'),
      })
    }

    return filteredProducts.map(
      (product, index) =>
        product.id ? (
          <ProductRow
            key={index}
            highlight={filterText}
            product={product}
            onSelect={onSelect}
            selectable={selectable}
          />
        ) : (
          <Table.Row className="productListMessage" key={index}>
            <Table.Cell disabled colSpan="999">
              <strong>
                <Icon {...config.icons.warning} />
                {product.message}
              </strong>
            </Table.Cell>
          </Table.Row>
        )
    )
  }

  render() {
    const dark = config.theme.dark

    // redux
    const { pathLeaves } = this.props

    const {
      inline,
      newFamily,
      compact,
      productsLoading,
      initialize,
    } = this.props

    const categoryFilterProps = {
      component: FormDropdown,
      name: 'categoryFilter',
      options: pathLeaves,
      placeholder: I18n.t(i18nkey + 'categories'),
    }

    const newFamProps = {
      content: I18n.t('admin.product.browser.new'),
      onClick: (event) => {
        event.preventDefault()
        initialize('new_product_family_modal', {
          article_number: '',
          title_de: '',
          title_fr: '',
          product_category_ids: null,
        })
      },
    }

    const searchProps = {
      component: FormInput,
      name: 'filterText',
      placeholder: I18n.t('global.filter'),
    }

    const headerProps = {
      inline,
      inverted: dark,
      title: I18n.t(i18nkey + 'title'),
      customActions: [
        <Field {...searchProps} icon="search" />,
        newFamily && (
          <Button {...newFamProps} primary labelPosition="right" icon="plus" />
        ),
      ],
    }

    return productsLoading ? (
      <ComponentPlaceholder />
    ) : (
      <div
        className={classNames([
          'productBrowser',
          'hide-print',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        {!compact && <ComponentHeader {...headerProps} />}

        <Segment
          attached
          className={classNames([
            'filterBar',
            inline ? 'tertiary' : 'primary',
            dark && 'inverted',
          ])}>
          <ProductFamilyModal />
          <Form.Group>
            <Field
              component={FormCheckbox}
              name="filterActive"
              label={
                <label>
                  <Icon {...config.icons.productStatusActive} />
                  {I18n.t('admin.product.status.active')}
                </label>
              }
            />
            <Field
              component={FormCheckbox}
              name="filterInactive"
              label={
                <label>
                  <Icon {...config.icons.productStatusInactive} />
                  {I18n.t('admin.product.status.inactive')}
                </label>
              }
            />
            <Field
              component={FormCheckbox}
              name="filterArchived"
              label={
                <label>
                  <Icon {...config.icons.productStatusArchived} />
                  {I18n.t('admin.product.status.archived')}
                </label>
              }
            />
          </Form.Group>

          <Form.Group>
            <Field
              component={FormCheckbox}
              name="filterProduct"
              label={
                <label>
                  <Icon {...config.icons.product} />
                  {I18n.t('admin.product.status.product')}
                </label>
              }
            />
            <Field
              component={FormCheckbox}
              name="filterFamily"
              label={
                <label>
                  <Icon {...config.icons.productFamily} />
                  {I18n.t('admin.product.status.family')}
                </label>
              }
            />
            <Field
              component={FormCheckbox}
              name="filterFamilyMember"
              label={
                <label>
                  <Icon {...config.icons.productFamilyMember} />
                  {I18n.t('admin.product.status.familyMember')}
                </label>
              }
            />
          </Form.Group>
        </Segment>

        <Segment
          attached
          className={classNames([
            'filterBar',
            'borderless',
            dark && 'inverted',
          ])}>
          <Field {...categoryFilterProps} search selection />
        </Segment>

        <Segment
          attached
          className={classNames(['payload', 'scroll', dark && 'inverted'])}>
          <Table
            compact
            size="small"
            singleLine
            selectable
            basic="very"
            className="spaced like-sortable">
            <Table.Body children={this.getProductRows()} />
          </Table>
        </Segment>
      </div>
    )
  }
}

ProductBrowser = connect(mapStateToProps, mapDispatchToProps)(ProductBrowser)
ProductBrowser = formValues(
  'categoryFilter',
  'filterActive',
  'filterInactive',
  'filterArchived',
  'filterProduct',
  'filterFamily',
  'filterFamilyMember',
  'filterText'
)(ProductBrowser)
ProductBrowser = reduxForm({
  form: 'product_browser',
  initialValues: {
    filterActive: true,
    filterInactive: false,
    filterArchived: false,
    filterProduct: true,
    filterFamily: true,
    filterFamilyMember: true,
    filterText: '',
    categoryFilter: -1,
  },
})(ProductBrowser)
export default ProductBrowser



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductBrowser.jsx